export function getNumberNights(arrival, departure){
    const start = Date.parse(arrival)
    const stop = Date.parse(departure)
    const minute = 60*1000; //milsec
    const hour = minute * 60;
    const day = hour * 24;
    const nights = Math.floor((stop - start)/day)
    return nights

}